import React, { useContext, useEffect, useState } from "react";
import { BgColorToTextColorMapFunc } from "../../CodesToColorMap";
import { DiseaseGroupContext } from "../../contexts/diseaseGroupContext";
import { isXamarin } from "../../services/mobileService";
import { LCNursingLogoSVG } from "../logos/LCNursingLogoSVG";
import { MesoLogo } from "../logos/MesoLogo";
import { MesoLogoCircleBW } from "../logos/MesoLogoCircleBW";
import { releaseDateLabel } from "../../configs/config.json";

export const StartupPageTemplate = ({ children }) => {
	const isMobile = isXamarin();
	const heightClass = isMobile ? "h-screen" : "h-full";
	const { theme } = useContext(DiseaseGroupContext);
	const [themePrimary] = useState(theme.primary());
	const [themeAltPrimary] = useState(theme.altprimary());
	const [themeContrast] = useState(theme.contrast());

	useEffect(() => {
		if (isMobile) {
			document.body.classList.add("h-screen");
		}
	}, []);

	let bottomLogo = null;

	const lcnukLogo = (
		<LCNursingLogoSVG
			className={`${
				theme.group === "generic"
					? "text-white"
					: BgColorToTextColorMapFunc(themePrimary, "text")
			} fill-current w-36 h-16`}
		/>
	);

	switch (theme.group) {
		case "lcnuk":
			bottomLogo = lcnukLogo;
			break;
		case "meso":
		case "mesoperitoneal":
			bottomLogo = <MesoLogo className={"px-10 h-16"} />;
			break;
		case "generic":
		default:
			bottomLogo = [
				<div key={"lcnukLogo"} className={"flex flex-col mx-3"}>
					{lcnukLogo}
				</div>,
				<div key={"mesoLogo"} className={"flex flex-col h-20 w-20 mx-3 px-1"}>
					<MesoLogoCircleBW />
				</div>,
			];
	}

	return (
		<>
			<div
				className={`wrapper ${themeAltPrimary.bg()} w-full ${heightClass} flex flex-col justify-center items-center ${theme.bkg()}`}
			>
				<div
					className={
						"flex-grow bkg bg-cover bg-center flex flex-col items-center w-full"
					}
				>
					<div className={"flex flex-1 text-center"}>
						<h1 className={"inline-block m-auto"}>
							<span
								className={`font-bold ${theme
									.contrast()
									.text()} text-3xl xs:text-4xl md:text-5xl leading-none block`}
							>
								Your Health
							</span>
							<span
								className={`${theme
									.symptom()
									.text()} text-5xl xs:text-6xl md:text-7xl leading-none block mb-4`}
							>
								Companion
							</span>
						</h1>
					</div>

					<div className="w-full mb-12 md:mb-24">{children}</div>
				</div>

				<div
					className={`flex-shrink w-full flex flex-col ${themeAltPrimary.bg()} items-center ${theme.bkg()}`}
				>
					<span className={"text-white block pt-1"}>Supporting</span>
					<div className={"flex flex-row pt-5 mb-3"}>{bottomLogo}</div>
					<span className={`text-white text-xs block m-safeAreaBottom`}>
						{!!releaseDateLabel ? `Release: ${releaseDateLabel}` : null}
					</span>
				</div>
			</div>
		</>
	);
};
